import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Mail, Lock, ArrowRight, Loader2 } from 'lucide-react';
import { GlassButton } from '../components/ui/GlassButton';
import logoPro from '../logo_pro.png';

export const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await login(email, password);
            navigate('/');
        } catch (err: any) {
            setError(err.message || 'Falha no login');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page min-h-screen flex items-center justify-center p-4">
            <div className="auth-card w-full max-w-md bg-white/5 border border-white/10 rounded-[32px] p-10 backdrop-blur-xl relative overflow-hidden">
                {/* Glow Effect */}
                <div className="absolute top-[-50%] left-[50%] -translate-x-1/2 w-80 h-80 bg-orange-500/10 rounded-full blur-[80px] pointer-events-none" />

                <div className="relative z-10">
                    <div className="text-center mb-10">
                        <img src={logoPro} alt="Hotlize" className="h-10 mx-auto mb-6" />
                        <h1 className="text-2xl font-bold text-white mb-2">Bem-vindo de volta</h1>
                        <p className="text-gray-400 text-sm">Entre na sua conta para continuar</p>
                    </div>

                    {error && (
                        <div className="bg-red-500/10 border border-red-500/20 text-red-500 p-4 rounded-xl mb-6 text-sm text-center">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="input-group-pro">
                            <label>E-MAIL</label>
                            <div className="input-wrapper">
                                <Mail size={18} className="text-gray-500" />
                                <input
                                    data-testid="login-email"
                                    type="email"
                                    placeholder="seu@email.com"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="input-group-pro">
                            <label>SENHA</label>
                            <div className="input-wrapper">
                                <Lock size={18} className="text-gray-500" />
                                <input
                                    data-testid="login-password"
                                    type="password"
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <GlassButton type="submit" className="w-full h-14" loading={loading} data-testid="login-submit">
                            {loading ? <Loader2 className="animate-spin" /> : <>ENTRAR <ArrowRight size={18} /></>}
                        </GlassButton>
                    </form>

                    <div className="mt-4 text-center">
                        <Link to="/esqueci-senha" className="text-gray-500 text-xs hover:text-orange-400 transition-colors">
                            Esqueceu sua senha?
                        </Link>
                    </div>

                    <div className="mt-6 text-center text-sm">
                        <span className="text-gray-500">Ainda n&atilde;o tem conta? </span>
                        <Link to="/cadastro" className="text-orange-500 font-bold hover:text-orange-400 transition-colors">
                            Cadastre-se agora
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
